import React, { useState, useEffect, lazy, Suspense } from "react";
import { useTestContext } from "../context/TestContext";

// Imports
import TitleText from "./TitleText";
//import Pagination from "./Pagination";
const PackageProductCard = lazy(() => import("./PackageProductCard"));

const PopularPackages = () => {
  const {
    fetchProductsByCategories,
    categoryProducts,
    categoryProductsPagination,
    popularProducts,
  } = useTestContext();
  const [currentPage, setCurrentPage] = useState(1);

  const filteredProducts = popularProducts.filter(
    (product) => product.productType === "package"
  ).sort((a, b) => {
    // Clean up the brandName by removing any \r and \n characters
    const cleanBrandNameA = a.brandName.replace(/[\r\n]+/g, '').trim();
    const cleanBrandNameB = b.brandName.replace(/[\r\n]+/g, '').trim();
    
    // First, sort by cleaned brandName in descending order
    if (cleanBrandNameB !== cleanBrandNameA) {
      return cleanBrandNameB.localeCompare(cleanBrandNameA);
    }
    
    // Then, if the brands are the same, sort by sellingPrice in ascending order
    const priceA = parseFloat(a.sellingPrice.replace(/,/g, '')); // Remove commas and convert to number
    const priceB = parseFloat(b.sellingPrice.replace(/,/g, '')); // Remove commas and convert to number
    return priceA - priceB; // Sort by price in ascending order
  });

  useEffect(() => {
    fetchProductsByCategories(currentPage);
  }, [currentPage]);

  return (
    <div className="w-full h-fit bg-whiteColor flex flex-col justify-start items-center p-[3%] lg:px-[6.5%] lg:py-[2%] space-y-[5%] lg:space-y-[2%]">
      <div className="w-[87.5%] h-fit flex justify-between items-center">
        <TitleText text="Popular Packages" />
      </div>
      <div className="w-[90%] h-fit grid grid-cols-1 lg:grid-cols-2 gap-x-0 gap-y-3 lg:gap-y-6 mx-auto justify-items-center">
        <Suspense
          fallback={
            <div className="w-full h-fit flex justify-center items-center">
              <span className="font-normal text-[7.5vw] lg:text-[1.25vw] text-textPrimaryColor">
                Loading package products...
              </span>
            </div>
          }
        >
          {filteredProducts?.map((item, index) => (
            <PackageProductCard data={item} key={index} />
          ))}
        </Suspense>
      </div>
    </div>
  );
};

export default PopularPackages;
